export const supportEmail = 'support@gyngercare.com';
const codeRequestEmail = 'code-request@gyngercare.com';

const fr = {
  appName: 'Gynger',
  appTagline: "L'app de suivi de santé des femmes",
  legal: {
    website: 'https://gyngercare.com/',
    termsAndPrivacy: 'https://gyngercare.com/mentionslegales/',
  },
  social: {
    instagram: 'https://www.instagram.com/gynger.care/',
    linkedIn: 'https://www.linkedin.com/company/gynger-care/',
    tiktok: 'https://www.tiktok.com/@gynger.care',
  },
  global: {
    user: {
      me: 'Moi',
    },
    support: {
      supportEmail,
      supportEmailWithSubject: `${supportEmail}?subject=Demande de support`,
      codeRequestEmailWithSubject: `${codeRequestEmail}?subject=Demande de code&body=Bonjour, j'aimerais créer un compte sur Gynger mais mon entreprise n'est pas partenaire. Pouvez-vous m'aider à obtenir un code ?`,
    },
    errors: {
      authentication: {
        title: 'Non autorisé',
        message: `Une erreur s'est produite lors de votre connexion. Veuillez recharger la page ou contacter le support à l'adresse ${supportEmail}, si le problème persiste.`,
      },
      '403': {
        title: 'Non autorisé',
        message: `Désolé, vous n'êtes pas autorisé à accéder à cette page. Veuillez contacter le support à l'adresse ${supportEmail}, si vous pensez que c'est une erreur.`,
      },
      '404': {
        title: 'Page non trouvée',
        message: `Désolé, la page que vous avez visitée n'existe pas. Veuillez contacter le support à l'adresse ${supportEmail}, si vous pensez que c'est une erreur.`,
      },
      unknown: 'Inconnu',
    },
    buttons: {
      cancel: 'Annuler',
      ok: 'OK',
      reset: 'Réinitialiser',
      update: 'Modifier',
      close: 'Fermer',
    },
    filters: {
      search: 'Filtrer',
      clear: 'Effacer les filtres',
    },
  },
  common: {
    yesterday: 'Hier',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    new: 'Nouveau',
    edit: 'Modifier',
    delete: 'Supprimer',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    empty: 'Aucun élément',
    save: 'Enregistrer',
    create: 'Créer',
    loading: 'Chargement...',
  },
  pushNotificationsOptIn: {
    title: 'Ne manquez rien !',
    body: 'Avec les notifications, recevez : ',
    activate: 'Activer les notifications',
    later: 'Plus tard',
    bullets: {
      0: 'Les messages de vos soignants',
      1: 'Vos rappels de cycles et de suivi',
      2: 'Vos infos santé',
    },
  },
  settings: {
    chatsSection: 'Messagerie',
    periodQuestions: 'Suivi des règles',
    cancel: 'Annuler',
    profile: {
      title: 'Mon profil',
      edit: 'Modifier',
    },
    chats: {
      emailNotifications: 'Recevoir des notifications de messages par email',
      emailNotificationsDescription: "Téléchargez l'application mobile pour une meilleure expérience de notifications",
    },
    accountSection: 'Mon compte',
    license: {
      noLicense: 'Aucun code entreprise ou mutuelle',
      currentLicense: 'Code',
      newLicense: 'Nouveau code',
      changeLicense: 'Modifier',
      saveLicense: 'Enregistrer',
      codeChanged: 'Code de license mis à jour',
      placeholder: 'Entrez votre nouveau code ici',
      expiresOn: 'Expire le {{date}}',
      expired: 'License expirée le {{date}}',
      errors: {
        invalidLicenseCode: "Ce code n'est pas valide",
        contractFull: `Le quota de licenses pour ce code est atteint, veuillez contacter le support au ${supportEmail}, ou votre entreprise ou mutuelle.`,
        contractExpired: 'Ce code de license a expiré.',
        default: "Une erreur s'est produite lors de la mise à jour du code de license",
      },
    },
    partner: {
      requestCreated: 'Demande prise en compte',
    },
    subscription: {
      currentSubscription: 'Abonnement',
      noSubscription: 'Aucun abonnement en cours',
      subscriptionInProgress: 'Abonnement illimité en cours',
      manage: 'Gérer',
      restorePurchases: 'Restaurer mes achats',
      restorePurchasesError: "Une erreur s'est produite lors de la restauration de vos achats",
      restorePurchasesSuccess: 'Vos achats ont été restaurés',
      manageStripeSubscription: `Pour modifier ou annuler votre abonnement, ou si vous avez une question ou un problème, contactez-nous à l'adresse <a>${supportEmail}</a>.<br /><br />Vous obtiendrez une réponse sous deux jours ouvrés.`,
      nonRenewingSubscription: "Semaine illimitée jusqu'au {{date}}",
    },
    supportParagraph: `Une question, une remarque ?<br/>Contactez-nous :<br/><br/><a>${supportEmail}</a>`,
  },
  menu: {
    home: 'Accueil',
    messagingHome: 'Messages',
    conversation: 'Conversations',
    newChat: 'Nouvelle question',
    settings: 'Paramètres',
    notFound: 'Page non trouvée',
    unauthorized: 'Non autorisé',
    login: 'Connexion',
    register: 'Créer mon compte',
    passwordReset: 'Mot de passe oublié',
    logout: 'Déconnexion',
    onboarding: 'Découvrir Gynger',
    moreInfo: 'Une question ?',
    support: 'Support',
    info: "M'informer",
    caregiverProfile: 'Profil',
    tracking: 'Mon suivi',
  },
  home: {
    greeting: 'Bonjour {{firstName}} !',
    pageTitle: 'Gynger',
    trackingCallToAction: 'Mon carnet de suivi',
    messages: {
      title: 'Messagerie',
      referralName: 'Laurine',
      referralTagline: 'Votre soignante référente',
      tagline: 'Une question ? Écrivez-nous !',
      callToAction: 'Découvrir',
      goToMessages: 'Ouvrir la messagerie',
      waitingForMe: 'En attente',
      inProgress: 'En cours',
      waitingForReassignment: 'En redirection',
    },
    tracking: {
      title: 'Mon suivi',
      description: 'Un suivi quotidien pour comprendre votre corps et réduire vos symptômes',
      fillSurvey: 'Remplir mon suivi quotidien',
      goToTracking: 'Mon suivi',
      graphLabel: 'Bien-être général',
    },
    info: {
      title: "M'informer",
      showMore: 'Voir tous les articles',
    },
    rebranding: {
      title: 'Gynger fait peau neuve !',
      subtitle: 'Découvrez notre nouvelle identité visuelle',
      dismiss: 'Fermer',
    },
    octobreRose: {
      title: 'Octobre rose',
      subtitle: 'Nos contenus spéciaux pour le mois de sensibilisation au cancer du sein',
    },
    social: {
      title: 'Suivez-nous sur les réseaux',
      description: 'Pour encore plus de conseils !',
    },
    partner: {
      title: 'Code partenaire',
      successMessage: 'Code partenaire validé. Notre équipe de soignants vous attend !',
      codeDescription: "Votre entreprise ou mutuelle vous offre l'accès à Gynger ? Renseignez votre code ici :",
      companyNameDescription:
        "Pas sûre d'être éligible ? Code oublié ? Renseignez le nom de votre entreprise ou mutuelle et nous vous guiderons.",
      codePlaceholder: 'Votre code partenaire',
      companyNamePlaceholder: 'Votre entreprise ou mutuelle',
      companyNameRequired: 'Veuillez entrer le nom de votre entreprise ou mutuelle',
      dontKnowCode: 'Je ne connais pas mon code',
      requestSubmittedMessage: 'Nous revenons vers vous très vite. Gardez un œil sur votre boîte mail !',
    },
  },
  paywall: {
    title: 'Ne restez plus sans réponse',
    subtitle: 'Échangez en illimité avec notre équipe de soignants pluridisciplinaire.',
    doYouHaveACode: 'Vous avez un code entreprise ou mutuelle ? Renseignez-le dans les <a>paramètres</a>.',
    conditions: 'Sans engagement. Annulez à tout moment.',
    perMonth: '/ mois',
    perQuarter: '/ 3 mois',
    perYear: '/ an',
    termsOfUse: 'Termes et conditions',
    privacyPolicy: 'Politique de confidentialité',
    testimonials: {
      1: 'Je gère beaucoup mieux mes crises de douleurs grâce à vos conseils',
      2: 'Un grand merci pour votre soutien et votre écoute',
      3: "J'ai enfin trouvé un soignant qui me comprend vraiment et qui peut m'aider",
    },
    whyPaywall: 'Pourquoi la messagerie est-elle payante ?',
    explainWhyPaywall:
      "Nous proposons une prise en charge pluridisciplinaire, continue et asynchrone à nos utilisatrices.  C'est pour permettre cette prise en charge plus adaptée que Gynger se structure autour d'une messagerie.<br /><br />Derrière cette messagerie, des médecins et paramédicaux qualifiés vous répondent. Leur temps est précieux et se doit d'être rémunéré.",
    webPaywall:
      "Les abonnements sont disponibles sur iOS et Android. Téléchargez l'application sur l'<appstore>App Store</appstore> ou <googleplay>Google Play</googleplay> pour en savoir plus.",
    oneWeekPrice: {
      title: '1 semaine',
      subtitle: 'Sans renouvellement',
    },
    monthlyPrice: {
      title: 'Mensuel',
      secondPricePhase: 'pour {{months}} mois puis {{priceString}} / mois',
      cancelAnytime: 'Annulable à tout moment',
      offerPercent: 'Offre à -{{percent}}%',
    },
    threeMonthPrice: {
      title: 'Trimestriel',
      secondPricePhase: 'pour {{months}} mois puis {{priceString}} / 3 mois',
      cancelAnytime: 'Annulable à tout moment',
      offerPercent: 'Offre à -{{percent}}%',
    },
    yearlyPrice: {
      title: 'Annuel',
      secondPricePhase: 'la première année puis {{priceString}} / an',
      freeMonths: '{{months}} mois offerts',
    },
    freeTest: {
      title: 'Essai gratuit',
      subtitle: "5 messages d'essai",
      ribbon: 'Pour découvrir',
    },
    purchaseButton: "Je m'abonne",
    purchaseButtonOneWeek: 'Je débloque une semaine',
    advantages: {
      '7j7': '6j / 7',
      unlimitedMessages: 'Messages illimités',
      answersIn24h: 'Réponses en 24h',
    },
    paymentSucceeded: {
      title: 'Abonnement activé',
      description: 'Bienvenue sur Gynger, nos soignants vous attendent !',
      callToAction: `C'est parti !`,
    },
    paymentFailed: {
      title: 'Erreur lors du paiement',
      description: 'Votre paiement a échoué. Veuillez réessayer.',
      needHelp: `Besoin d'aide ? Contactez-nous à l'adresse <a>${supportEmail}</a>.`,
      callToAction: 'Réessayer',
    },
    freeMessagesButton: {
      title: 'Je teste',
      freeMessages: 'messages gratuits',
    },
    freeMessagesEnabled: {
      title: 'Test gratuit activé',
      description: 'Vous avez {{count}} messages gratuits pour tester Gynger.',
      callToAction: 'Découvrir',
    },
    promoCode: {
      haveCode: 'Vous avez un code promo ?',
      placeholder: 'Entrez votre code',
      submit: 'Valider',
      syncing: 'Confirmation...',
      invalid: 'Code promo invalide.',
      unsupported: 'Les codes promo ne sont pas supportés sur cette plateforme.',
      iosInstructions:
        "Vous allez être redirigé(e) vers l'App Store pour utiliser votre code. Revenez dans l'application après la validation.",
      iosSuccess: "Utilisez votre code dans l'App Store, puis revenez ici.",
      iosSyncing: "Confirmation de l'achat...",
      iosSynced: 'Achats synchronisés !',
      androidSuccess: 'Code promo appliqué ! Les prix ont été mis à jour.',
    },
  },

  loginRegister: {
    welcome: {
      title: 'Bienvenue sur Gynger !',
      description: 'Les experts de la santé des femmes dans votre poche.',
    },
    title: {
      login: 'Connectez-vous à votre compte',
      register: 'Créez un compte Gynger',
    },
    description: {
      register: 'Créez un compte avec votre mot de passe, définissez un mot de passe et renseignez le code.',
      registerAskIfCode: "Avez-vous un code d'accès à Gynger ?",
      registerNoCode:
        "Pour l'instant, l'accès à Gynger requiert un code fourni par les employeurs ou mutuelles partenaires de Gynger.",
    },
    linkToSite: {
      tagline: 'Gynger, la messagerie gynécologique pour toutes.',
      link: "Cliquez ici pour plus d'informations.",
    },
    fields: {
      email: {
        title: 'E-mail',
        placeholder: 'E-mail',
        errors: {
          notEmail: "Format d'email invalide",
        },
      },
      emailConfirmation: {
        title: "Confirmation de l'e-mail",
        placeholder: 'Confirmez votre e-mail',
        errors: {
          required: 'Veuillez confirmer votre e-mail',
          emailsNotMatch: 'Vos e-mails ne correspondent pas',
        },
      },
      password: {
        title: 'Mot de passe',
        placeholder: 'Mot de passe',
        errors: {
          required: 'Le mot de passe est requis',
          minLength: 'Votre mot de passe doit contenir au moins 12 caractères.',
          lowercase: 'Votre mot de passe doit contenir au moins une lettre minuscule.',
          uppercase: 'Votre mot de passe doit contenir au moins une lettre majuscule.',
          digit: 'Votre mot de passe doit contenir au moins un chiffre.',
          password_too_common: 'Ce mot de passe est trop courant.',
          password_entirely_numeric: 'Ce mot de passe ne peut pas être entièrement numérique.',
          password_too_short: 'Votre mot de passe doit contenir au moins 12 caractères.',
          password_too_similar: 'Ce mot de passe est trop similaire à vos autres informations personnelles.',
          password_no_upper: 'Votre mot de passe doit contenir au moins une lettre majuscule.',
          password_no_lower: 'Votre mot de passe doit contenir au moins une lettre minuscule.',
          password_no_digit: 'Votre mot de passe doit contenir au moins un chiffre.',
          requirements:
            'Votre mot de passe doit contenir au moins 12 caractères avec au moins une lettre majuscule, une lettre minuscule et un chiffre.',
        },
      },
      passwordConfirmation: {
        title: 'Confirmation du mot de passe',
        placeholder: 'Confirmation du mot de passe',
        errors: {
          required: 'Veuillez confirmer votre nouveau mot de passe',
          minLength: 'Votre mot de passe doit contenir au moins 12 caractères',
          passwordsNotMatch: 'Vos mots de passe ne correspondent pas',
        },
      },
      firstName: {
        title: 'Prénom',
        placeholder: 'Prénom',
        errors: {
          required: 'Le prénom est requis',
        },
      },
      lastName: {
        title: 'Nom',
        placeholder: 'Nom de famille',
        errors: {
          required: 'Votre nom de famille est requis',
        },
      },
      licenseCode: {
        title: 'License',
        placeholder: "Code d'accès",
        description: 'Si vous avez un code entreprise ou mutuelle, renseignez-le ici :',
        errors: {
          required: 'Le code de la license est requis',
        },
        full: 'Le quota de licenses pour ce code est atteint mais vous pouvez toujours créer un compte gratuit sans code.',
        expired: 'Ce code de license a expiré. Vous pouvez créer un compte gratuit sans code.',
      },
      tc_and_privacy_policy_consent: {
        title: "J'ai lu et j'accepte les CGU et la politique de confidentialité",
        errors: {
          required: 'Vous devez accepter',
        },
      },
      personal_information_access_consent: {
        title:
          "J'accepte que les informations que je partage via la messagerie soient accessibles à tous les soignants de Gynger Care.",
        errors: {
          required: 'Vous devez accepter',
        },
      },
      email_notifications_consent: {
        title: "J'accepte de recevoir des notifications par email de la part de Gynger Care",
      },
    },
    actions: {
      back: 'Retour',
      login: 'Connexion',
      register: 'Créer mon compte',
      next: 'Continuer',
      alreadyRegistered: 'Déjà un compte ? Authentifiez-vous avec votre email',
      noAccount: 'Pas de compte ? Créez un compte avec votre email',
      passwordReset: 'Mot de passe oublié ?',
      iHaveAnEnterpriseCode: "J'ai un code entreprise",
      iHaveAnInsuranceCode: "J'ai un code mutuelle",
      iDontHaveACode: "Je n'ai pas de code d'accès",
      understoodNoCode: "J'ai compris",
      retry: 'Réessayer',
    },
    licenseCodeStep: {
      title: "Avez-vous un code d'accès ?",
      description:
        "Si votre <b>entreprise</b> ou <b>mutuelle</b> vous a communiqué un code d'accès, renseignez-le ici.",
      submitButton: 'Valider',
      skipButton: "Je n'ai pas de code",
    },
    errors: {
      login: `Une erreur s'est produite lors de la connexion. Merci de contacter ${supportEmail}`,
      register: `Une erreur s'est produite lors de la création de votre compte. Merci de contacter ${supportEmail}`,
      licenseCodeInvalid: `Ce code de license n'est pas valide. Contactez ${supportEmail} en cas de problème.`,
      unauthorized: `E-mail ou mot de passe non reconnu. Si vous rencontrez des problèmes, contactez ${supportEmail}`,
      disconnected: `Vous avez été déconnecté(e). Veuillez vous reconnecter.`,
      errorOccurred: `Une erreur de connexion s'est produite. Veuillez réessayer.`,
    },
  },
  passwordReset: {
    title: 'Réinitialisation du mot de passe',
    description: {
      sendEmail:
        'Remplissez ce formulaire avec votre email. Un lien vous sera envoyé pour réinitialiser votre mot de passe',
      reset: 'Utilisez ce formulaire pour réinitialiser votre mot de passe. Définissez un nouveau mot de passe',
    },
    fields: {
      email: {
        title: 'E-mail',
        placeholder: 'E-mail',
        errors: {
          notEmail: "Format d'email invalide",
        },
      },
      password: {
        title: 'Mot de passe',
        placeholder: 'Votre nouveau mot de passe (12 caractères min)',
        errors: {
          required: 'Veuillez définir un nouveau mot de passe',
          minLength: 'Votre mot de passe doit contenir au moins 12 caractères',
          passwordsNotMatch: 'Vos mots de passe ne correspondent pas',
        },
      },
      passwordConfirmation: {
        title: 'Confirmation du mot de passe',
        placeholder: 'Confirmation du mot de passe',
        errors: {
          required: 'Veuillez confirmer votre nouveau mot de passe',
          minLength: 'Votre mot de passe doit contenir au moins 12 caractères',
          passwordsNotMatch: 'Vos mots de passe ne correspondent pas',
        },
      },
    },
    actions: {
      sendEmail: 'Envoyer le lien',
      reset: 'Réinitialiser',
    },
    success: {
      sendEmail:
        'Un email vous a été envoyé. Cliquez sur le lien que vous avez reçu pour réinitialiser votre mot de passe',
      reset: 'Votre mot de passe a été réinitialisé',
    },
    errors: {
      sendEmail: `Une erreur s'est produite lors de l'envoi du lien. Merci de contacter ${supportEmail}`,
      reset: `Une erreur s'est produite lors de la réinitialisation de votre mot de passe. Merci de contacter ${supportEmail}`,
    },
  },
  caregivers: {
    qualificationLevels: {
      medical: 'Médical',
      paramedical: 'Paramédical',
      alternative_medicine: 'Médecines douces',
    },
    list: {
      errors: {
        fetch: "Une erreur s'est produite lors du chargement de la liste des spécialistes",
      },
    },
    actions: {
      requestOwnerChange: {
        success: 'La conversation a été transférée à un spécialiste',
        error: "Une erreur s'est produite lors du transfert de la conversation à un spécialiste",
      },
      requestCaregiverAssignment: {
        success: 'La conversation a été transférée au soignant',
        error: "Une erreur s'est produite lors du transfert de la conversation au soignant",
      },
      statusChange: {
        success: 'Le statut de la conversation a été mis à jour.',
        error: "Une erreur s'est produite lors du changement de statut de la conversation",
      },
      selfAssign: {
        success: 'Vous vous êtes assigné la conversation !',
        error: "Une erreur s'est produite lors du transfert de la conversation vers vous-même",
      },
      rejectAssignment: {
        success: 'Vous avez refusé cette conversation ; elle est de nouveau disponible pour les autres soignants.',
        error: "Une erreur s'est produite lors du refus de la conversation",
      },
      createNewConversationWithGroup: {
        success: 'Orientation validée',
        error: "Une erreur s'est produite lors de l'orientation",
      },
    },
  },
  patientProfile: {
    feels_pain_or_discomfort: 'Ressentez-vous des douleurs ou des inconforts ?',
    yes: 'Oui',
    no: 'Non',
    noData: 'Dossier non renseigné',
    symptoms: 'Symptômes ressentis',
    noSymptoms: 'Aucun symptôme ressenti',
    pathologies: 'Pathologies diagnostiquées',
    noPathologies: 'Aucune pathologie diagnostiquée',
    expectations: 'Attentes envers Gynger',
    noExpectations: 'Aucune attente',
    questions: 'Sujets qui posent question',
    noQuestions: 'Aucune question',
    file: 'Dossier patiente',
    bornIn: 'Née en {{year}} ({{age}} ans)',
    takesContraception: 'Prend une contraception',
    takesNoContraception: 'Ne prend pas de contraception',
    hasChildren: 'A des enfants',
    hasNoChildren: "N'a pas d'enfants",
    isPregnant: 'Est enceinte',
    isNotPregnant: "N'est pas enceinte",
    isTryingToConceive: "Essaye d'avoir des enfants",
    isNotTryingToConceive: "N'essaye pas d'avoir des enfants",
    isTakingTreatment: 'Prend un traitement',
    isNotTakingTreatment: 'Ne prend pas de traitement',
    chronicSymptoms: 'Symptômes ou douleurs chroniques',
    symptomImpact: 'Impact des symptômes sur la qualité de vie',
    consultationCount: 'Avez-vous consulté pour ces symptômes ?',
    noAnswer: 'Non renseigné',
  },
  chats: {
    title: 'Messagerie',
    loadingPage: {
      message: 'Chargement de la messagerie...',
    },
    inAppNotification: {
      defaultBody: 'Nouveau message',
    },
    takenOverNotification: {
      title: 'Conversation attribuée',
      body: 'Cette conversation a été prise en charge par un autre soignant.',
    },
    statuses: {
      ASSIGNMENT_TO_GROUP_ASKED: 'En attente',
      ASSIGNMENT_TO_CAREGIVER_ASKED: 'En attente',
      ASSIGNED_TO_CAREGIVER: 'En cours',
      CLOSED: 'Clôturée',
      ON_HOLD: 'En pause',
      WAITING_FOR_FIRST_RESPONSE: 'En attente de prise en charge',
      FIRST_ASSIGNMENT_REJECTED: 'En attente de prise en charge (refusée)',
      FIRST_ASSIGNMENT_TIMED_OUT: 'En attente de prise en charge (relance)',
    },
    paywall: {
      limitReached: 'Vous avez atteint la limite de messages gratuits.',
      messagesRemaining_one: 'Il vous reste {{count}} message gratuit.',
      messagesRemaining_other: 'Il vous reste {{count}} messages gratuits.',
      discoverUnlimited: 'Échangez en illimité avec nos soignants',
      understandWhy: 'Pourquoi la messagerie est-elle payante ?',
    },
    explainer: {
      title: 'Messagerie',
      exceptSundays: '* sauf les dimanches et jours fériés',
      noInspiration: "Pas d'inspiration pour ce premier message ?",
      inCaseOfEmergency: "En cas d'urgence, contactez le 15 ou le 112.",
      firstMessageModal: `
        <p>Ça peut être impressionnant de faire le premier pas, c'est normal !</p>
        <p>Faites comme si vous arriviez chez votre médecin et que vous deviez répondre à une question simple:</p>
        <quote>Qu'est-ce qui vous amène ?</quote>
        <ul>
          <li>
            <strong>vous pouvez être brève</strong> : si les soignants Gynger ont besoin d'informations supplémentaires,
            ils vous les demanderont.
          </li>
          <li>
            <strong>vous pouvez être plus longue</strong> : si votre situation est complexe, vous pouvez la détailler
          </li>
        </ul>
        <p>
          De manière générale, n'hésitez pas à décrire votre <strong>situation</strong> (douleurs, symptômes, pathologies éventuelles, ...) et votre 
          <strong>objectif</strong> (comprendre et/ou diminuer les symptômes, savoir si vous devez consulter, avoir un
          deuxième avis, etc.).
        </p>
        <p>Tout premier message est valide et trouvera une réponse, mais voici quelques exemples:</p>
      `,
    },
    explainerV2: {
      heroTitle: 'Les experts de la santé des femmes <italic>dans votre poche.</italic>',
      heroSubtitle:
        'Échangez avec une équipe de soignantes spécialisées en santé des femmes. Une référente unique, des spécialistes à vos côtés — tout passe par le chat.',
      caregiverName: 'Laurine, votre soignante référente',
      caregiverRole: 'Vous répond sous 24h',
      patientBubble: "Bonjour, j'ai une question concernant...",
      caregiverBubble: "Bonjour ! Je suis là pour vous écouter. Pouvez-vous m'en dire un peu plus ?",
      startConversationCta: 'Démarrer ma conversation',
      trustBadges: 'Confidentiel · Sécurisé · Bienveillant',
      howItWorksLabel: 'Comment ça marche',
      howItWorksTitle: 'Quatre étapes, <italic>une présence continue.</italic>',
      step1Title: 'Écrivez-nous',
      step1Description:
        "Envoyez un premier message en quelques mots : une question, un symptôme inattendu, ou un besoin d'accompagnement.",
      step2Title: 'Votre soignante référente vous prend en charge',
      step2Description:
        'Elle vous pose les questions utiles, vous répond, et reste votre interlocutrice privilégiée à chaque instant.',
      step3Title: 'Échange avec un spécialiste',
      step3Description: "Si c'est pertinent, votre référente ouvre des conversations avec d'autres spécialistes.",
      step4Title: 'Un suivi continu',
      step4Description: 'Vos soignants vous accompagnent dans vos besoins, jour après jour.',
      teamLabel: 'Notre équipe pluridisciplinaire',
      teamTitle: 'Toutes les expertises de la santé des femmes, dans un seul chat.',
      teamSubtitle: "Votre référente vous met en lien, quand c'est nécessaire, avec :",
      specialties: {
        groupMedical: 'Médical et paramédical',
        groupSoft: 'Médecines douces',
        gynecologists: 'Gynécologues',
        nutritionists: 'Nutritionnistes',
        physiotherapists: 'Kinésithérapeutes',
        midwives: 'Sages-femmes',
        psychologists: 'Psychologues',
        childcareNurses: 'Puéricultrices',
        osteopaths: 'Ostéopathes',
        nurses: 'Infirmières',
        naturopaths: 'Naturopathes',
        sophrologists: 'Sophrologues',
      },
      quote: '<italic>Chez nous, pas de chatbot IA !</italic>',
      quoteDescription:
        'Toutes nos réponses sont écrites par des soignants spécialisés en santé des femmes, bienveillants et disponibles.',
    },
    goToExplainer: 'Comment fonctionne la messagerie ?',
    subtitle: {
      unassigned: 'Demandes de groupe',
      myRequest: 'Mes demandes',
      waitingForReassignment: 'En redirection',
      assigned: 'En cours',
      closed: 'Fermées',
      onHold: 'En pause',
      history: 'Historique',
      summary: 'Notes',
      myConversations: 'Mes conversations',
      waitingRoom: "Salle d'attente",
      needsReply: 'En attente de réponse',
      replied: 'Répondu',
    },
    caregiverStatus: {
      new: 'Nouvelle',
      waitingForMe: 'Pour moi',
      inNeedOfAttention: 'En attente',
      freeTrial: 'Essai gratuit',
      licenseCode: 'Code partenaire',
      paidSubscription: 'Abonnement payant',
    },
    caregiverDelayWarning_one:
      'Cette conversation est sans réponse depuis {{count}} jour. Veuillez y répondre, la réorienter ou la clôturer.',
    caregiverDelayWarning_other:
      'Cette conversation est sans réponse depuis {{count}} jours. Veuillez y répondre, la réorienter ou la clôturer.',
    caregiverDelayWarningWithoutClosing_one:
      'Cette conversation est sans réponse depuis {{count}} jour. Veuillez y répondre ou la réorienter.',
    caregiverDelayWarningWithoutClosing_other:
      'Cette conversation est sans réponse depuis {{count}} jours. Veuillez y répondre ou la réorienter.',
    noNotificationsCTA: 'Soyez notifié(e) de nos réponses',
    caregivers: {
      first: 'Marion, Sage-femme',
      second: 'Aurore, Sage-femme',
      third: 'Laurine, Sage-femme',
    },
    actions: {
      transferTo: 'Orienter vers... ',
      reassignToCaregiver: 'Réorienter...',
      assignToCaregiver: 'Assigner à un soignant',
      summary: 'Notes',
      history: 'Historique',
      selfAssign: 'Prendre en charge',
      rejectAssignment: 'Refuser',
      initiateConversation: 'Je parle à un soignant',
      button: 'Actions',
      putOnHold: 'Mettre en pause',
      putOnHoldDetails:
        'La conversation reste ouverte pour la patiente. Un nouveau message rouvre la conversation automatiquement.',
      close: 'Clôturer',
      openNewConversation: 'Ouvrir une nouvelle conversation',
      myDocuments: 'Mes documents',
      dossier: 'Dossier',
      searchMessages: 'Rechercher dans les messages',
      searchShortLabel: 'Recherche',
      searchMessagesPlaceholder: 'Rechercher dans la conversation…',
      searchMatchCounter: '{{current}} / {{total}}',
      searchPreviousMatch: 'Correspondance précédente',
      searchNextMatch: 'Correspondance suivante',
      closeMessageSearch: 'Fermer la recherche',
      shareToTeam: "Partager à l'équipe Gynger",
      shareToTeamSuccess: 'Lien copié dans le presse-papier',
    },
    dossier: {
      documents: 'Documents',
      noDocuments: 'Aucun document partagé par la patiente.',
      notesPlaceholder: 'Ajouter des notes sur cette conversation...',
      questionnaires: 'Questionnaires',
      onboardingQuestionnaire: "Questionnaire d'accueil",
      medicalQuestionnaire: 'Bilan santé',
      viewQuestionnaire: 'Voir',
      noOnboardingQuestionnaire: 'Indisponible',
      noMedicalQuestionnaire: 'Non renseigné',
    },
    fields: {
      message: {
        placeholder: 'Tapez votre message ...',
      },
    },
    replySuggestion: {
      title: 'Suggestion',
      accept: 'Accepter',
      edit: 'Éditer',
      reject: 'Refuser',
    },
    templates: {
      title: 'Modèles',
      newTemplate: 'Nouveau modèle',
      editTemplate: 'Modifier le modèle',
      confirmDelete: 'Voulez-vous supprimer ce modèle ?',
      fields: {
        name: 'Nom du modèle',
        messageText: 'Texte du message',
      },
      helperTags:
        'Astuce : vous pouvez utiliser les tags @PRENOM et @NOM pour vous référer à la patiente et @MON_PRENOM et @MON_NOM pour vous référer à vous-même',
    },
    linkConfirmation: {
      title: 'Ouvrir ce lien ?',
      content:
        "Vous êtes sur le point d'ouvrir un lien externe partagé par une utilisatrice : {{url}}. Voulez-vous continuer ?",
      open: 'Ouvrir le lien',
    },
    copyMessage: 'Copier',
    editMessage: 'Modifier le message',
    messageEdited: 'Modifié',
    messageDeleted: 'Ce message a été supprimé',
    deleteMessage: {
      action: 'Supprimer',
      title: 'Supprimer ce message',
      content: 'Cette action est irréversible.',
      confirm: 'Supprimer',
    },
    noCaregiver: {
      avatar: 'NA',
      name: {
        forPatient: 'Équipe Gynger',
        forCaregiver: 'Équipe Gynger',
      },
      extraConversationMessage: {
        forPatient:
          "Merci pour votre message, les soignants Gynger vous répondront au plus vite !\n\nS'il s'agit d'une urgence, contactez le 15 ou le 112.\n\nSi vous avez d'autres questions, n'hésitez pas à les poser dans cette conversation.",
      },
    },
    noLastMessage: 'Pas encore de messages',
    deletedLastMessage: 'Message supprimé',
    inactiveConversation: {
      patient: {
        title: 'Une autre question ?',
        description: 'Vous pouvez la poser ici, votre soignant reprendra la conversation où elle en était.',
      },
      caregiver: {
        title: 'Gynger suit votre rythme',
        description:
          'Vous pouvez reprendre cette conversation ou poser une autre question <b>après autant de temps</b> que vous le souhaitez, vous serez toujours prise en charge.',
      },
    },
    summary: {
      title: 'Compte-rendu',
      subtitle: 'Visible par les autres soignants uniquement',
      noSummary: "L'équipe de soignants n'a pas encore entré de notes pour cette conversation.",
      save: 'Sauver',
      caregiverPublicWarning: 'Attention ! Ces notes sont visibles par les patientes',
      summaryPlaceholder:
        "Entrez ici la situation de la patiente et les recommandations faites par l'équipe de soignants",
      summarySaved: 'Notes mises à jour',
      summarySaveError: "Une erreur s'est produite lors de l'envoi des notes",
      summaryLoadError: "Une erreur s'est produite lors du chargement des notes",
    },
    list: {
      noChatsTitle: 'Pas de conversation pour le moment',
      noChats: {
        forPatient:
          'Pas encore de conversations.\n\nPosez vos questions à notre équipe de soignantes et soignants spécialisés en santé des femmes !',
        forCaregiver: "Pas de conversations pour le moment. Veuillez attendre qu'une patiente pose une question",
      },
      errors: {
        fetch: "Une erreur s'est produite lors du chargement de vos conversations",
        sendMessage: "Une erreur s'est produite lors de l'envoi de votre message",
      },
    },
    new: {
      titleAskQuestion: 'Poser une question',
      titleHealthCheckUp: 'Faire le bilan',
      introMessageAskQuestion: `Bonjour, \n\n Posez-nous vos questions ici, l'équipe de soignants Gynger vous répondra au plus vite!\n\nS'il s'agit d'une urgence, contactez le 15 ou le 112.`,
      introMessageHealthCheckUp:
        "Bonjour,\n\nDécrivez-nous ici la raison de votre venue sur Gynger, et nous allons vous mettre en relation sous 24 heures avec votre sage-femme référente.\n\nElle vous aidera à dresser votre bilan santé, et nous ferons ensuite de notre mieux pour vous aider à aller mieux !\n\nS'il s'agit d'une urgence, contactez le 15 ou le 112.",
      introMessageSenderId: 'Gynger-User-Id',
      introMessageSenderName: 'Gynger',
      exampleMessages: [
        'Bonjour, mes douleurs menstruelles augmentent depuis plusieurs mois, que faire ?',
        "Bonjour, quels conseils nutrition avez-vous si je suis atteinte d'endométriose ?",
        'Bonjour, comment augmenter mes chances de tomber enceinte ?',
        'Bonjour, comment augmenter ma libido ?',
        'Bonjour, comment trouver la bonne contraception ?',
        'Bonjour, pourquoi ai-je des douleurs abdominales ?',
        'Bonjour, quels vaccins dois-je réaliser pour mes enfants ?',
        "Bonjour, comment savoir si j'approche de la ménopause ?",
      ],
    },
    dashboardView: {
      topicToCover: "Si vous avez d'autres questions, n'hésitez pas à les poser dans votre conversation existante !",
      caregiversTeam: "L'équipe de soignants",
      morePain: 'Mes douleurs menstruelles augmentent depuis plusieurs mois, que faire ?',
      whatIsGynger: 'Une question sur Gynger ?',
      anyQuestion: 'Une question, un problème ponctuel ou récurrent ?',
      quickAnswer: 'Notre équipe de soignants vous répond sous 24 heures.',
    },
  },
  webSockets: {
    messages: {
      error: "Une erreur s'est produite, vous devrez peut-être recharger la page pour voir les derniers messages",
      connecting: 'Connexion à notre système de messagerie ...',
      connected: 'Vous recevrez les derniers messages',
    },
  },
  octobreRose: {
    title: 'Octobre rose',
    sections: {
      understand: 'Comprendre',
      risk: 'Risque',
      recognise: 'Reconnaître',
      screening: 'Dépistage',
      diagnosis: 'Diagnostic',
      treatments: 'Traitements',
      afterCancer: 'Après-cancer',
    },
  },
  infoPage: {
    description: `Ces articles sont proposés par nos soignants pour mieux comprendre votre santé et améliorer votre bien-être.\nNous en publions régulièrement!`,
    recentlyRead: 'Récents',
    noPosts: 'Aucun article trouvé',
    new: 'Nouveau',
    read: 'Lu',
    search: {
      placeholder: 'Rechercher',
    },
    // The categorised Infos page (areas, themes, sections)
    structure: {
      searchPlaceholder: 'Endométriose, pilule, mycose…',
      recommended: 'Recommandés pour vous',
      favourites: 'Vos favoris',
      favouritesEmpty: 'Vos sujets favoris apparaîtront ici',
      bookmark: 'Ajouter à mes favoris',
      unbookmark: 'Retirer de mes favoris',
      allTopics: 'Tous les sujets',
      articles_one: '{{count}} article',
      articles_other: '{{count}} articles',
      read_one: '{{count}} lu',
      read_other: '{{count}} lus',
      startHere: 'Commencer ici',
      seeAllArticles: 'Voir les {{count}} articles',
      also: 'Et aussi',
      seeAlso: 'Voir aussi',
      inArea: 'dans {{area}}',
      topics: 'Sujets',
      articlesTitle: 'Articles',
      noResults: 'Aucun sujet ni article trouvé',
      askMidwife: {
        title: 'Une question ? Une sage-femme vous répond.',
        button: 'Poser ma question',
      },
    },
    article: {
      relatedPosts: 'Aller plus loin',
      writtenBy: 'Écrit par {{author}} le {{date}}',
      chatCallToAction: {
        title: "Besoin d'un avis médical ?",
        description: 'Notre équipe vous répond sous 24 heures.',
      },
    },
  },
  caregiverQualification: {
    medical: 'Médical',
    paramedical: 'Paramédical',
    alternative_medicine: 'Médecines douces',
  },
  caregiverProfile: {
    title: 'Profil',
    errors: {
      fetch: "Une erreur s'est produite lors du chargement du profil de cet expert",
    },
  },
  onboarding: {
    carousel: {
      title: 'Bienvenue sur ',
      titleEnd: ' !',
      pages: {
        one: {
          text1start: 'Une équipe de soins ',
          text1Bold1: 'pluridisciplinaire',
          text1middle: ' et ',
          text1Bold2: 'spécialisée',
          text1end: ' en santé des femmes',
          text2start: 'Pour répondre à toutes vos questions ou vous accompagner à long terme via une messagerie ',
          text2Bold1: 'rapide',
          text2middle: ' et ',
          text2Bold2: 'sécurisée',
        },
        tracking: {
          textStart: 'Un outil de suivi pour ',
          textBold1: 'mieux comprendre',
          textMiddle: ' votre corps, vos symptômes et ',
          textBold2: 'réduire',
          textEnd: ' leur impact sur votre quotidien',
        },
        two: {
          textStart: 'Des ',
          textBold1: 'articles',
          textMiddle1: ' écrits par nos ',
          textBold2: 'professionnels',
          textMiddle2: ' pour ',
          textBold3: 'découvrir',
          textMiddle3: ' et mieux ',
          textBold4: 'comprendre',
        },
        three: {
          textStart: 'Un ',
          textBold1: 'annuaire',
          textMiddle1: ' de soignants spécialisés en santé des femmes ',
          textBold2: 'proches',
          textEnd: ' de chez vous',
        },
        four: {
          cards: {
            questions: 'Je pose une question à un soignant',
            track: 'Je commence mon carnet de suivi',
            check: 'Je fais un bilan avec ma sage-femme',
            learn: 'Je veux en apprendre plus',
            expert: 'Je cherche un expert près de chez moi',
          },
        },
      },
      buttons: {
        next: "Ce n'est pas tout !",
        end: 'Continuer',
      },
    },
    carouselV2: {
      pages: {
        welcome: {
          title: 'Bienvenue sur Gynger, {{firstName}} !',
          titleNoName: 'Bienvenue sur Gynger !',
          subtitle: 'Découvrez comment Gynger vous accompagne au quotidien',
        },
        team: {
          title: 'Une équipe médicale bienveillante à votre écoute',
          subtitle: 'Toutes les expertises de la santé des femmes, réunies dans une messagerie.',
          groupMedical: 'Médical et paramédical',
          groupSoft: 'Médecines douces',
          specialties: {
            gynecologists: 'Gynécologues',
            midwives: 'Sages-femmes',
            physiotherapists: 'Kinésithérapeutes',
            nutritionists: 'Nutritionnistes',
            psychologists: 'Psychologues',
            childcareNurses: 'Puéricultrices',
            osteopaths: 'Ostéopathes',
            nurses: 'Infirmières',
            naturopaths: 'Naturopathes',
            sophrologists: 'Sophrologues',
          },
        },
        response: {
          title: 'Des réponses en moins de 24h',
          subtitle: 'Pour mieux vous rassurer, orienter et accompagner.',
        },
        tracking: {
          title: 'Un suivi de cycles et de symptômes',
          subtitle: 'Comprenez votre corps et réduisez l’impact de vos symptômes au quotidien.',
        },
        content: {
          title: 'Des informations fiables et sourcées',
          subtitle: 'Des articles écrits et vérifiés par nos soignants spécialisés en santé des femmes.',
        },
      },
      buttons: {
        discover: 'Découvrir',
        next: 'Continuer',
        end: 'Commencer',
      },
    },
    questionnaire: {
      greeting: 'Bienvenue',
      description: 'Pour mieux vous aider, nous avons quelques questions à vous poser.',
      start: "C'est parti !",

      yes: 'Oui',
      no: 'Non',
      continue: 'Continuer',
      thankYou: 'Merci',
      congratulations: 'Bravo',
      later: 'Plus tard',

      painQuestion: 'Ressentez-vous des douleurs ou des inconforts ?',

      symptoms: {
        question: 'Avez-vous des symptômes ?',
        description: 'Ils peuvent être récurrents ou ponctuels.',
        otherSymptoms: 'Autres...',
        saveSymptoms: 'Continuer',
        noSymptoms: 'Je ne ressens aucun symptôme',
        otherSymptomsPlaceholder: "Entrez ici d'autres symptômes ou des précisions sur vos symptômes",
      },

      pathologies: {
        question: "Avez-vous été diagnostiquée d'une pathologie ?",
        otherPathologies: 'Autres...',
        savePathologies: 'Continuer',
        noPathologies: 'Je ne pense pas',
        otherPathologiesPlaceholder: "Entrez ici d'autres pathologies ou des précisions sur vos pathologies",
        options: {
          // TODO translations
          ENDOMETRIOSIS: 'Endométriose',
          SOPK: 'SOPK',
          FIBROME: 'Fibrome',
          ADENOMYOMATOSIS: 'Adénomyose',
          BREAST_CANCER: 'Cancer du sein',
          UTERUS_CANCER: "Cancer du col de l'utérus",
          PMS: 'Syndrome pré-menstruel',
        },
      },

      chronicSymptoms: {
        question: 'Ressentez-vous un symptôme ou une douleur chronique ?',
        description:
          'Depuis plus de 3 mois, en incluant les douleurs de règles, fatigue importante, troubles digestifs, ...',
        options: {
          NO: 'Non',
          LESS_THAN_ONE_YEAR: "Oui, depuis moins d'un an",
          ONE_TO_THREE_YEARS: 'Oui, depuis 1 à 3 ans',
          MORE_THAN_THREE_YEARS: 'Oui, depuis plus de 3 ans',
        },
        impact: {
          question: "Quel est l'impact de ces symptômes sur votre qualité de vie ?",
          options: {
            NONE: 'Inexistant',
            LOW: 'Faible',
            MODERATE: 'Modéré',
            IMPORTANT: 'Important',
            VERY_IMPORTANT: 'Très important',
          },
        },
        consultation: {
          question: 'Avez-vous déjà consulté pour ces symptômes ?',
          options: {
            NO: 'Non',
            ONE_TO_THREE: 'Oui, 1 à 3 fois',
            MORE_THAN_THREE: 'Oui, plus de 3 fois',
          },
        },
        continue: 'Continuer',
      },

      expectations: {
        question: 'Que souhaitez-vous obtenir de Gynger ?',
        otherExpectations: 'Autre...',
        saveExpectations: 'Continuer',
        otherExpectationsPlaceholder: 'Expliquez-nous comment nous pouvons vous aider !',
        noExpectations: 'Je ne sais pas',
        options: {
          ADVICE: 'Des conseils pour aller mieux',
          ANSWERS: 'Des réponses à mes questions',
          SPEAK_TO_SPECIALIST: 'Parler à un spécialiste',
          UNDERSTAND_SYMPTOMS: 'Suivre et comprendre mes symptômes',
          SECOND_OPINION: 'Un second avis',
          RELIABLE_INFORMATION: 'Des informations fiables',
        },
      },

      questions: {
        question: 'Avez-vous des questions sur les sujets suivants ?',
        otherQuestions: 'Autre...',
        saveQuestions: 'Continuer',
        noQuestions: 'Aucun de ces sujets',
        otherQuestionsPlaceholder: 'Symptômes inhabituels, douleurs, ...',
        options: {
          CONTRACEPTION: 'Contraception',
          MENSTRUATION: 'Règles',
          FERTILITY: 'Fertilité',
          MENOPAUSE: 'Ménopause',
          PATHOLOGIES: 'Pathologies',
          TREATMENTS: 'Traitements',
          SEXUALITY: 'Sexualité',
        },
      },

      firstThankYou: 'Merci pour vos réponses',
      postProductSurveyDescription:
        "Notre équipe de soignants peut vous accompagner, il ne vous reste plus qu'à remplir votre dossier.",
      file: {
        title: 'Votre dossier',
        birthYear: 'Année de naissance',
        birthYearPlaceholder: 'Sélectionner',
        doYouTakeContraception: 'Prenez-vous une contraception ?',
        doYouHaveChildren: 'Avez-vous des enfants ?',
        areYouPregnant: 'Êtes-vous enceinte ?',
        areYouTryingToConceive: "Essayez-vous d'avoir des enfants ?",
        areYouTakingAnyMedication: 'Prenez-vous un traitement ?',
        requiredField: 'Veuillez sélectionner une option',
      },
      postFile: {
        description: 'Vous avez fait le premier pas vers une <bold>meilleure santé</bold>.',
        letsGo: 'Continuons ensemble !',
      },
    },
  },
  faq: {
    subtitle: "Gynger est l'application de suivi de santé des femmes pour toutes.",
    networks: 'Retrouvez-nous sur les réseaux !',
    questions: 'Questions fréquentes',
  },
  documents: {
    view: 'Voir',
    edit: 'Renommer',
    shareWith: 'Partager avec {{caregiverName}}',
    unshareWith: 'Ne plus partager avec ce soignant',
    shared: 'Documents partagés',
    sharedWith: 'Partagés avec {{caregiverName}}',
    notShared: 'Documents non partagés',
    noSharedDocuments: 'Aucun document partagé pour le moment.',
    upload: 'Télécharger un document',
    uploadWithCaregiver: 'Partager un nouveau document avec {{caregiverName}}',
    confirmDelete: 'Êtes-vous sûr(e) de vouloir supprimer "{{fileName}}" ?',
    uploadSuccess: 'Document téléchargé',
    uploadAndShareSuccess: 'Document téléchargé et partagé',
    shareSuccess: 'Document partagé',
    unshareSuccess: 'Accès retiré',
    deleteSuccess: 'Document supprimé',
    updateSuccess: 'Document renommé',
    editName: 'Renommer le document',
    enterName: 'Entrer le nom du document',
    reshareInfo:
      'Vos documents sont visibles uniquement aux soignants à qui vous les avez partagés. Vous pouvez partager un document déjà mis en ligne à ce soignant ci-dessous.',
    errors: {
      loadError: 'Échec du chargement des documents.',
      uploadError: 'Échec du téléchargement du document.',
      shareError: 'Échec du partage du document.',
      unshareError: "Échec de la suppression de l'accès.",
      deleteError: 'Échec de la suppression du document.',
      updateError: 'Échec de la mise à jour du nom du document.',
      emptyName: 'Le nom du document ne peut pas être vide.',
      invalidType: 'Type de fichier non autorisé. Seuls les images (JPG, PNG) et les PDF sont supportés.',
      fileTooLarge: 'La taille du fichier dépasse la taille maximale autorisée de 30 Mo.',
      noCaregiver: 'Aucun soignant assigné à cette conversation.',
      ONLY_OWNER_CAN_UPDATE: 'Seul le propriétaire du document peut le modifier.',
      ONLY_OWNER_CAN_SHARE: 'Seul le propriétaire du document peut le partager.',
      ONLY_OWNER_CAN_UNSHARE: "Seul le propriétaire du document peut retirer l'accès.",
      CAREGIVER_ID_REQUIRED: "L'identifiant du soignant est requis.",
      CAREGIVER_NOT_FOUND: 'Soignant introuvable.',
      ACCESS_NOT_FOUND: 'Accès introuvable.',
      INVALID_FILE_TYPE: 'Type de fichier non autorisé. Seuls les images (JPG, PNG) et les PDF sont supportés.',
      FILE_TOO_LARGE: 'La taille du fichier dépasse la taille maximale autorisée de 30 Mo.',
      DAILY_UPLOAD_LIMIT_REACHED:
        'Vous avez atteint la limite de téléchargement quotidienne de 10 fichiers. Veuillez réessayer demain.',
    },
    paywall: {
      uploadOnlyForPaidUsers: 'Débloquez le partage de documents avec nos soignants',
    },
  },
  preventionJourney: {
    title: 'Ma prévention',
    description: 'Un article par semaine pour assurer votre prévention santé.',
    start: 'Commencer',
    notificationsRequired: 'Activez les notifications pour suivre ce parcours',
    notificationSettings: 'Paramètres de notifications',
    nextArticle: 'Revenez la semaine prochaine pour le prochain article !',
    journeyComplete:
      'Votre parcours prévention est terminé mais notre équipe de soignants vous répond toujours sur la messagerie.',
    enableNotificationsSuggestion: 'Activez les notifications pour ne pas manquer le prochain article.',
    articleFallbackTitle: 'Article {{id}}',
  },
  symptomTracking: {
    title: 'Mon suivi',
    description:
      "Comprenez mieux votre corps, la régularité des symptômes et des douleurs, l'impact de votre nutrition ou de vos traitements en suivant votre santé au quotidien.",
    error: {
      title: 'Une erreur est survenue. Veuillez réessayer plus tard.',
    },
    noSymptoms: 'Aucun symptôme',
    modules: {
      cycleLengthTitle: 'Cycles',
      cycleLengthHelp: {
        title: 'Durée des cycles',
        description:
          "Cette section vous montre la durée de vos cycles menstruels au fil du temps. Un cycle menstruel commence le premier jour de vos règles et se termine la veille du premier jour des règles suivantes.<br /><br />La variation maximale est calculée comme le plus grand écart constaté entre la durée d'un cycle et la moyenne de tous les cycles.",
        howToRead: 'Comment lire ces graphiques ?',
        description2:
          "Chaque point représente un jour. Un <redDot/> représente un jour de règles, un <midBlueDot/> est un jour de phase fertile, et un <darkBlueDot/> le jour d'ovulation.",
        description3:
          "Pour le cycle en cours, il est impossible de prédire avec certitude la période fertile et le jour d'ovulation, puisqu'elle dépend des prochaines règles qui n'ont pas encore eu lieu. Les points en contours <lightBlueDot/> <darkBlueDot/> représentent donc une prédiction basée sur la durée moyenne des cycles passés.",
        description4:
          "Le dernier point du cycle en cours est entouré d'un cercle <todayDot/> : il représente toujours la date d'aujourd'hui.",
      },
      compareCyclesTitle: 'Comparer les cycles',
      compareCyclesHelp: {
        title: 'Comparer les cycles',
        description:
          "Cette fonctionnalité vous permet de comparer vos cycles entre eux pour identifier des tendances.<br /><br />Les cycles sont affichés l'un au-dessus de l'autre, et sont alignés sur le premier jour des règles.",
      },
      historyTitle: 'Historique',
      perCycle: 'Par cycle',
    },
    periodReminder: {
      question: 'Voulez-vous un rappel quelques jours avant vos prochaines règles ?',
      later: 'Plus tard',
      yes: 'Oui',
      enabled: 'Rappel activé !',
      laterExplanation: "Vous pourrez activer votre rappel à tout moment en cliquant sur l'icône de rappel ci-dessus.",
      ok: 'OK',
      enable: 'Activer',
      disabled: 'désactivé',
      description: 'Recevez un rappel quelques jours avant vos règles pour être préparée le jour J',
      notifications: {
        d_minus_3: 'Votre prochain cycle peut démarrer dans 3 jours',
        d_minus_1: 'Votre prochain cycle peut démarrer demain',
        d_plus_1: "Vos règles ont commencé ? N'oubliez pas de remplir votre suivi pour prévoir les prochaines !",
        d_plus_4: "Vos règles ont commencé ? N'oubliez pas de remplir votre suivi pour prévoir les prochaines !",
        d_plus_10:
          "N'oubliez pas de remplir votre suivi pour prévoir vos prochaines règles ! Nos soignants vous répondent en cas de cycles irréguliers.",
      },
    },
    nextPeriod: {
      nextPeriodAround: 'Prochaines règles autour du',
      nextPeriodFrom: 'Prochaines règles à partir de',
      nextPeriodIn: 'Prochaines règles dans',
      endPeriodIn: 'Fin des règles dans',
      nextPeriod: 'Prochaines règles',
      plusMinusDays_one: '± {{plusMinusDays}} jour',
      plusMinusDays_other: '± {{plusMinusDays}} jours',
      day: 'jour',
      days: 'jours',
      to: 'à',
      dates: 'Dates',
      helpTitle: 'Prédiction des prochaines règles',
      help: "La date de vos prochaines règles est calculée en fonction de l'historique de vos derniers cycles renseignés.<br /><br />Les dates indiquées correspondent à la période pendant laquelle vos prochaines règles arriveront probablement.<br /><br />Cette prédiction est purement informative, dépend des données renseignées et peut être fausse, particulièrement dans le cas de cycles irréguliers.",
    },
    history: {
      historyDescription: "L'historique montre 3 mois jusqu'à la date sélectionnée",
      fillAtLeast3Days: 'Renseignez au moins 3 jours de suivi pour voir votre historique',
      fillPastSymptoms: 'Renseigner des symptômes passés',
      fillAtLeast3Cycles: 'Renseignez au moins 3 cycles pour voir votre historique',
      fillCycles: 'Renseigner mes cycles',
      selectGraphsPlaceholder: 'Sélectionnez les graphiques à afficher',
    },
    cycleDetail: {
      dates: 'Dates',
      datesInProgress: '{{startDate}} - En cours',
      duration: 'Durée du cycle',
      durationInProgress: 'En cours',
      today: "Aujourd'hui",
      periodDuration: 'Durée des règles',
      probableFertilityPeriod: 'Phase probable de fertilité',
      probableFertilityPeriodDay: 'Du <b>{{start}}</b> au <b>{{end}}</b>',
      probableOvulationDay: "Date probable de l'ovulation",
      durationDays: '{{count}} jours',
      periodDurationDays: '{{count}} jours',
      cyclesNotRegularEnough:
        'Vos cycles semblent trop irréguliers pour vous proposer des prédictions fiables.\n\nAvez-vous pensé à en parler à nos soignants sur la <a>messagerie<a/> ?',
    },
    cycles: {
      calendarHelper: 'Cliquez sur un jour pour rajouter ou éditer des infos',
      averageDuration: 'Durée moyenne',
      maxVariation: 'Variation maximale',
      standardDeviation: 'Variation moyenne',
      currentCycle: 'Cycle actuel',
      previousCycles: 'Cycles précédents',
      inProgress: 'En cours - {{count}}<sup>e</sup> jour',
      day: 'jour',
      fillMoreCycles_one: 'Renseignez encore {{count}} cycle',
      fillMoreCycles_other: 'Renseignez encore {{count}} cycles',
      validate: 'Valider',
      fillPastCycles: 'Renseigner mes cycles passés',
      fillCycles: 'Renseigner mes cycles',
      fillAtLeastOneDay: 'Renseignez au moins un jour de règles',
      fillAtLeastThreeCycles: 'Renseignez au moins 3 cycles pour voir votre historique',
      pastCycles: 'Cycles passés',
      deleteCycle: 'Supprimer le cycle',
      noPeriods: "Je n'ai pas / plus mes règles",
      disableExplanation:
        "Si vous n'avez pas ou plus de règles, vous pouvez en désactiver le suivi. Certaines fonctionnalités seront désactivées.<br /><br />Il sera toujours possible de réactiver le suivi de règles par la suite.",
      disable: 'Je désactive le suivi de règles',
      legend: {
        period: 'Jour de règles',
        fertile: 'Période de fertilité prédite',
        ovulation: 'Jour d’ovulation prédit',
      },
      cycleDetails: 'Détails du cycle',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      endDatePredicted: 'Date de fin prédite',
      length: 'Durée',
      lengthPredicted: 'Durée prédite',
      periodLength: 'Durée des règles',
      ovulation: 'Jour d’ovulation',
      ovulationPredicted: 'Jour d’ovulation prédit',
      fertilityWindow: 'Fenêtre de fertilité',
      fertilityWindowPredicted: 'Fenêtre de fertilité prédite',
      fertilityWarning: 'Ces dates sont des estimations, pas un moyen de contraception.',
      showMore: 'Afficher plus de cycles',
      showLess: 'Afficher moins de cycles',
    },
    compare: {
      generalState: 'État général',
      period: 'Règles',
      pain: 'Douleurs',
      symptoms: 'Symptômes',
      fillToCompare: 'Renseignez vos symptômes pour les comparer à travers les cycles',
      fillMultipleCycles: 'Renseignez vos symptômes sur plusieurs cycles pour les comparer',
      fillAtLeastTwoCycles: 'Renseignez au moins 2 cycles',
      fillAtLeastOneSymptomDay: 'Renseignez au moins 1 jour de symptômes',
      cycleLabel: 'Cycle du {{date}}',
    },
    calendar: {
      noSymptomsReported: 'Aucun symptômes renseignés.',
      viewCalendar: 'Plus tôt',
      accessFullCalendar: 'Ouvrir le calendrier',
    },
    tracking: {
      disabled: 'Le suivi des règles est désactivé',
      reactivate: 'Réactiver',
    },
    graphs: {
      generalState: 'État général',
      menstruation: 'Règles',
      pain: 'Douleurs',
      symptoms: 'Symptômes',
      vaginalDischarges: 'Pertes vaginales',
      sexualActivity: 'Vie sexuelle',
      bodyTemperature: 'Température basale corporelle',
      notes: 'Notes',
      otherSymptoms: 'Autres symptômes et précisions',
    },
    notes: {
      noNotesYet: 'Pas de notes pour le moment',
    },
    reminder: {
      periodReminder: 'Rappel de règles',
      dailyReminder: 'Rappel quotidien',
      active: 'Mon rappel',
      inactive: 'Aucun rappel configuré',
      description: 'Un suivi quotidien sur plusieurs mois peut aider un diagnostic.',
      setTimeQuestion: 'À quelle heure souhaitez-vous remplir votre suivi quotidien ?',
      enableNotifications: 'Activez les notifications pour recevoir votre rappel',
      enable: 'Activer',
      disable: 'Désactiver',
      change: 'Modifier',
      callToAction: 'Activer mon rappel',
      mobileOnly:
        "Ce rappel est uniquement disponible sur notre application mobile, que vous pouvez télécharger depuis l'App Store ou le Play Store.",
    },
    notification: {
      dailyReminder: "Bonjour {{name}}, c'est l'heure de remplir votre suivi quotidien !",
    },
    actions: {
      fillDailySurvey: 'Remplir mon suivi quotidien',
      editDailySurvey: 'Modifier',
    },
    noDataForDay: 'Aucun suivi pour cette journée',
    survey: {
      greeting: 'Bonjour',
      howAreYouToday: 'État général',
      howWereYou: 'Quel était votre état général le {{date}} ?',
      loading: 'Chargement...',

      // États généraux
      generalState: {
        veryGood: 'Très bon',
        good: 'Bon',
        average: 'Moyen',
        bad: 'Mauvais',
        veryBad: 'Très mauvais',
      },

      menstruation: {
        periodQuestion: 'Règles',
        yes: 'Oui',
        no: 'Non',
        noPeriod: "Je n'ai pas/plus de règles",
        skipPeriodWarning:
          'Vous pouvez <b>désactiver le suivi de règles</b>, mais vous pourrez toujours le réactiver dans les paramètres.',
        understood: 'Désactiver le suivi de règles',

        // Quantité de menstruations
        menstruationAmount: "Quelle est l'intensité de vos règles ?",
        none: 'Aucunes',
        low: 'Faibles',
        medium: 'Moyennes',
        high: 'Abondantes',
        veryHigh: 'Très abondantes',
      },

      // Niveau de douleur
      pain: {
        painQuestion: 'Douleurs',
        none: 'Aucune',
        light: 'Légères',
        moderate: 'Modérées',
        strong: 'Fortes',
        intense: 'Intenses',
      },

      // Autres symptômes
      symptoms: {
        otherSymptoms: 'Symptômes',
        FATIGUE: 'Fatigue',
        DIGESTIVE: 'Troubles digestifs',
        URINARY: 'Troubles urinaires',
        SEXUAL: 'Troubles sexuels',
        BLEEDING: 'Saignements inhabituels',
        MOOD: "Troubles d'humeur",
        MENTAL: 'Troubles mentaux',
        DIZZINESS: 'Vertiges',
        BELLY_CRAMP: 'Crampes au ventre',
        BACK_PAIN: 'Mal de dos',
        HEADACHE: 'Migraines',
        NAUSEA: 'Nausées',
        BLOATING: 'Ballonnements',
        other: 'Autre symptôme...',
        otherSymptomsDescription: "Renseignez ici d'autres symptômes ou des précisions sur vos symptômes",
        saveSymptoms: 'Enregistrer mes symptômes',
        noSymptoms: "Je n'ai ressenti aucun symptôme",
      },

      // Pertes vaginales
      vaginalDischarges: {
        title: 'Pertes vaginales',
        NONE: 'Aucune',
        SPOTTING: 'Spotting',
        STICKY: 'Visqueuses',
        CREAMY: 'Crémeuses',
        EGG_WHITE: "Blanc d'œuf",
        UNUSUAL: 'Inhabituelles',
      },

      // Vie sexuelle
      sexualActivity: {
        title: 'Vie sexuelle',
        NONE: 'Pas de rapport sexuel',
        PROTECTED: 'Rapport protégé',
        UNPROTECTED: 'Rapport non protégé',
      },

      // Température basale corporelle
      bodyTemperature: {
        title: 'Température basale corporelle',
      },

      reminder: {
        question: 'Rappel de suivi quotidien',
        explain: 'Un suivi régulier peut aider à comprendre, diagnostiquer et traiter.',
        noThanks: 'Pas tout de suite',
        doNotAskAgain: 'Ne plus me le demander',
      },

      fertility: {
        ovulationDay: "Jour d'ovulation estimé",
        fertilityDay: 'Jour fertile estimé',
        possibleOvulationDay: "Jour d'ovulation possible",
        possibleFertilityDay: 'Jour fertile possible',
        predictionWarning: 'Cette prédiction peut avancer ou reculer de plusieurs jours en cas de cycles irréguliers',
      },

      // Commentaires
      addComment: 'Notes et commentaires',
      freeTextDescription:
        'Entrez ici vos notres libres sur votre nutrition, vos traitements, votre ressenti ou tout autre chose...',
      saveFollowUp: 'Enregistrer',
      missingAnswers: 'Veuillez répondre à toutes les questions pour enregistrer votre suivi',
    },
  },
  medicalProfile: {
    homepage: {
      cta: 'Continuez votre bilan',
      ctaDescription: 'Complétez le questionnaire pour recevoir vos conseils personnalisés.',
      pendingReview: 'Mon bilan santé',
      pendingReviewSubtitle: 'En attente de revue par nos soignants',
      pendingReviewBadge: 'Envoyé',
      inReview: 'Mon bilan santé',
      inReviewSubtitle: 'Revue en cours',
      reviewed: 'Mon profil médical',
      viewProfile: 'Voir mon profil',
      notStartedBadge: 'À FAIRE',
      duration: '10 min',
      notStartedTitle: 'Mon bilan santé',
      notStartedSubtitle: 'Faites le tour de votre santé, recevez des conseils personnalisés.',
      notStartedCta: 'Commencer le questionnaire',
    },
    questionnaire: {
      title: 'Bilan santé',
      greeting: 'Faisons le tour de votre santé ensemble, ',
      description1: 'Ce questionnaire vous prendra environ <b>dix minutes</b> à compléter.',
      description2:
        'Vos réponses, confidentielles, seront analysées par notre équipe de soignants avant de vous proposer des <b>recommandations personnalisées</b>.',
      description3: "Votre progrès est <b>sauvé au fil de l'eau</b>, vous pourrez y revenir à tout moment.",
      start: 'Commencer',
      continue: 'Continuer',
      save: 'Enregistrer et continuer',
      finish: 'Terminer',
      saving: 'Enregistrement...',
      saved: 'Modifications enregistrées ✓',
      saveEdit: 'Enregistrer les modifications',
      savingProgress: 'Votre progression est sauvegardée automatiquement.',
      completed: {
        title: 'Bilan complété',
        description:
          'Notre équipe de soignants vous enverra des <b>recommandations personnalisées</b> via la messagerie dans les plus <b>brefs délais</b>.',
        goHome: "Retour à l'accueil",
      },
      processingInfo: {
        title: 'Votre bilan est entre les mains de nos soignants.',
        description1:
          'Notre équipe de soignants vous contactera via la <b>messagerie</b> pour vous proposer des recommandations personnalisées',
        description2: 'Le traitement se fait généralement en <b>moins de 24h</b>',
        description3: 'Vous pouvez <b>modifier vos réponses</b> quand vous le voulez',
        cta: 'Modifier',
      },
      yes: 'Oui',
      no: 'Non',
      selectPlaceholder: 'Sélectionner...',
      yearPlaceholder: 'Sélectionnez...',
      textareaPlaceholder: 'Votre réponse...',
    },
    caregiver: {
      needsReviewTag: 'Bilan en attente',
      alertTitle: 'Bilan santé à étudier',
      alertDescription:
        "Cette patiente a complété son bilan santé. Veuillez l'étudier pour lui proposer des recommandations personnalisées.",
      viewQuestionnaire: 'Consulter',
      startReview: 'Commencer',
      reviewInProgressTitle: 'Bilan santé en cours',
      whatToDo: 'Que faire',
      reviewInProgressDescription:
        "Veuillez noter les points d'attention dans les notes patiente, creuser certains points avec la patiente, et lui faire des recommandations personnalisées.",
      finishReview: 'Terminer',
      markAsReviewed: 'Marquer comme revu',
      markingAsReviewed: 'En cours...',
      questionnaireModalTitle: 'Bilan santé',
      noResponse: 'Aucune réponse disponible.',
      reviewedBy: 'Revu le {{date}}',
      highlights: {
        sectionTitle: 'Points à retenir',
        toggleTooltipAdd: 'Mettre en avant',
        toggleTooltipRemove: 'Retirer des points à retenir',
      },
    },
  },
};

export default fr;
